import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { saveGenerateAvatar } from "../../../../api/avatars";
import { setStep } from "../../../../store/customeUplaod/customeUploadSlice";
import { getFromLocal } from "../../../../utils/localStorage";
import { UploadImage } from "../UploadImage";
import AvatarCanvas from "./AvatarCanvas";

const rules = [
  "Front-Facing: Face directly towards the camera.",
  "Proper Lighting: Use decent lighting to avoid shadows.",
  "Clean Background: Prefer a white or black background.",
  "Head Position: Capture your full head, from the top of your hair to the bottom of your chin.",
];

const mistakes = [
  {
    src: "/tool/dashboard/static/images/Dos1.png",
    text: "Avoid wearing eyeglasses ",
  },
  {
    src: "/tool/dashboard/static/images/Dos2.png",
    text: "Avoid Sidepose photographs",
  },
  {
    src: "/tool/dashboard/static/images/Dos3.png",
    text: "Avoid wearing Headgear",
  },
  {
    src: "/tool/dashboard/static/images/Dos4.png",
    text: "Avoid showing teeth or smiling",
  },
  {
    src: "/tool/dashboard/static/images/Dos5.png",
    text: "Avoid covering the face",
  },
  {
    src: "/tool/dashboard/static/images/Dos6.png",
    text: "Avoid artwork photographs",
  },
];

const NewAvatar = ({ setNewAvatar }) => {
  const dispatch = useDispatch();
  const [generatedImage, setGeneratedImage] = useState();
  const [checked, setChecked] = useState(false);
  const [isAgree, setIsAgree] = useState(false);

  const handleBack = () => {
    setNewAvatar(false);
  };
  const handleCheckboxChange = () => {
    setChecked(!isAgree);
  };
  const handleAgree = () => {
    setIsAgree(true);
    dispatch(setStep("upload"));
  };

  const handleGenerate = async () => {
    const userId = getFromLocal("userId");
    return saveGenerateAvatar(userId, generatedImage);
  };

  return (
    <div className="grid w-full gap-8 p-3 overflow-auto">
      {isAgree ? (
        <UploadImage
          handleGenerate={handleGenerate}
          handleBack={handleBack}
          directUpload
        >
          {(file) => {
            return (
              <AvatarCanvas file={file} setGeneratedImage={setGeneratedImage} />
            );
          }}
        </UploadImage>
      ) : (
        <>
          {/* <div className="flex gap-5 items-center">
            <div onClick={handleBack} className="flex gap-2 items-center">
              <img
                src="/tool/dashboard/static/images/backsquare.png"
                alt="backicon"
                width={24}
              />
              <p className="font-normal text-xs">BACK</p>
            </div>
            <p className="font-semibold text-sm">Create new avatar</p>
          </div> */}

          <div className="flex   pt-4">
            <div className="w-[50%] pl-4 pr-10 ">
              <p className="font-bold text-lg ">Avatar Photo Guidelines</p>

              <div className=" mt-4 text-gray-500 mr-[30%] flex text-xs font-semibold  justify-between">
                <div className="flex items-center">
                  <img
                    className="w-[15px] h-[15px] mr-2"
                    src="/tool/dashboard/static/images/greentick.png"
                  />
                  <h1>JPEG Format</h1>
                </div>

                <div className="flex items-center">
                  <img
                    className="w-[15px] h-[15px] mr-2"
                    src="/tool/dashboard/static/images/greentick.png"
                  />
                  <h1>500 X 500 px</h1>
                </div>

                <div className="flex items-center">
                  <img
                    className="w-[15px] h-[15px] mr-2"
                    src="/tool/dashboard/static/images/greentick.png"
                  />
                  <h1>1MB or less</h1>
                </div>
              </div>

              <ul className="my-8 grid gap-2 list-disc pl-5">
                {rules.map((rule, index) => {
                  const [boldText, normalText] = rule.split(":", 2);
                  return (
                    <li key={index} className="font-normal text-xs">
                      <span className="font-bold">{boldText}</span>
                      {normalText && <span>: {normalText.trim()}</span>}
                    </li>
                  );
                })}
              </ul>
              <div>
                <h1 className="font-bold text-sm">Reference Examples</h1>
                <div className="flex my-4">
                  <img
                    className="mr-2 w-[100px] h-[100px] "
                    src="/tool/dashboard/static/images/refi1.png"
                  />
                  <img
                    className="mr-2 w-[100px] h-[100px] "
                    src="/tool/dashboard/static/images/refi2.png"
                  />
                  <img
                    className="mr-2 w-[100px] h-[100px] "
                    src="/tool/dashboard/static/images/refi3.png"
                  />
                </div>
              </div>

              <div className="flex gap-2 items-start">
                <input type="checkbox" onChange={handleCheckboxChange} />
                <p
                  className="font-normal 
          text-xs  leading-4"
                >
                  The user agrees to upload only his/her photograph. In case the
                  user uploads someone else’s photograph, he/she will be solely
                  responsible for any legal actions/liability arising from it.
                </p>
              </div>
            </div>

            <div className="grid gap-3  border-l-2 border-gray-400 w-[50%]">
              <p className="font-bold text-base mb-[-30%] ml-8">
                Please avoid these mistakes <br /> for best results &#33;
              </p>
              <div className="grid grid-cols-2 gap-6 p-4">
                {mistakes.map((item, index) => (
                  <div key={index} className="flex text-sm">
                    <img
                      src={item.src}
                      alt={item.text}
                      className=" w-[80px] h-[80px] object-cover"
                    />
                    <p className="mt-4 mx-4">{item.text}</p>
                  </div>
                ))}
              </div>
              {/* <div>
                
              </div> */}
            </div>
          </div>
        </>
      )}
      {!isAgree && (
        <div className=" mt-[-6vh] flex justify-end">
          <button
            disabled={!checked}
            onClick={handleAgree}
            className="bg-black rounded-md border border-black text-white w-36 h-8 text-sm"
          >
            Agree
          </button>
        </div>
      )}
    </div>
  );
};
export default NewAvatar;
